import { useState, useEffect } from "react";
import Buttons from "./Button/Buttons";
import ModalPopupContact from "./ModalPopupContact";
import { useTranslation } from "react-i18next";

const BlogSidebarStickyMobile = () => {
  const { t } = useTranslation(["blog"]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isExpanded && event.target.classList.contains("mobile-overlay")) setIsExpanded(false);
    };
    if (isExpanded) document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isExpanded]);

  const bullet = (key, fallback) => t(`sidebar.bullets.${key}`, fallback);

  return (
    <>
      {!isModalOpen && (
        <div className='fixed bottom-0 left-0 w-full z-[9999] hidden md:block'>
          {isExpanded && <div className='mobile-overlay fixed inset-0 bg-black/20 z-0' />}
          <div className='relative'>
            {!isExpanded && (
              <div className='bg-inaqgold p-6 flex items-center justify-between cursor-pointer shadow-lg' onClick={() => setIsExpanded(true)}>
                <div className='flex items-center'>
                  <img src='/assets/img/webp/inaq_logo_2x_web_white.webp' loading='lazy' alt='INAQ Logo' className='w-6 mr-6' />
                  <div className="text-white text-[13px] font-['Oxanium']">{t("sidebar.mobileTagline", "B2B marketingová agentúra INAQ")}</div>
                </div>
                <div className='text-white text-sm'>⌃</div>
              </div>
            )}
            {isExpanded && (
              <div className='bg-inaqgold p-6 rounded-t-md shadow-lg'>
                <div className='flex justify-between items-center mb-3'>
                  <div className='flex items-center'><img src='/assets/img/webp/inaq_logo_2x_web_white.webp' loading='lazy' alt='INAQ Logo' className='w-6 mr-6' /><div className="text-[13px] font-['Oxanium'] text-white">{t("sidebar.mobileTagline", "B2B marketingová agentúra INAQ")}</div></div>
                  <button className='text-white text-2xl' onClick={() => setIsExpanded(false)} aria-label='Close'>×</button>
                </div>
                <div className='border-t border-white opacity-50 mb-3'></div>
                <h3 className='text-white text-[14px] mt-2 font-normal mb-2 font-["Oxanium"] text-center'>{t("sidebar.heading", "Čo viete získať spoluprácou s nami?")}</h3>
                <div className='flex justify-center mb-4'><div className='max-w-[200px] mx-auto'><ul className='text-white/90 list-square text-[12px] font-rubik font-light [&>li]:before:text-white/80 [&>li]:marker:text-white/80 pl-10 pr-5'><li className='mb-2 hover:text-white'>{bullet("strategy", "obsahová stratégia")}</li><li className='mb-2 hover:text-white'>{bullet("analytics", "výkonnostná analytika")}</li><li className='mb-2 hover:text-white'>{bullet("brand", "brandová komunikácia")}</li><li className='mb-2 hover:text-white'>{bullet("ai", "AI automatizácia")}</li></ul></div></div>
                <div className='flex justify-center'><Buttons type='button' onClick={() => { setIsModalOpen(true); setIsExpanded(false); }} className='rounded-sm font-medium font-rubik uppercase shadow-[0_0_30px_rgba(0,0,0,0.08)] hover:text-black py-2 px-4 text-center' themeColor={["#fff", "#fff"]} size='xs' backgroundColor='transparent' color='#212529' borderRadius='rounded-sm' title={t("sidebar.cta", "Vyplňte formulár")} /></div>
              </div>
            )}
          </div>
        </div>
      )}
      <ModalPopupContact isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default BlogSidebarStickyMobile;
